module.exports = __webpack_public_path__ + "img/website.01424aa8.jpg";